<template>
  <div class="searchBar">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'searchBar',
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped>
.searchBar{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  min-height: 40px;
  padding: 4px 20px 4px 0;
  box-sizing: border-box;
  background-color: #ffffff;
  border-bottom: 0.5px solid #dcdcdc;
}
</style>
